import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { getLiveStatus } from '../services/api';
import ChurchLogo from './ChurchLogo';
import './Navbar.css';

const NAV_LINKS = [
  { to: '/', label: 'Accueil' },
  { to: '/about', label: 'À Propos' },
  { to: '/events', label: 'Événements' },
  { to: '/sermons', label: 'Sermons' },
  { to: '/ministries', label: 'Ministères' },
  { to: '/gallery', label: 'Galerie' },
  { to: '/donation', label: 'Donner' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [liveStatus, setLiveStatus] = useState({ is_live: false, youtube_url: '', stream_title: '' });

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Poll live status every 30 seconds
  useEffect(() => {
    const fetchLive = () => getLiveStatus().then(setLiveStatus).catch(() => {});
    fetchLive();
    const interval = setInterval(fetchLive, 30000);
    return () => clearInterval(interval);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setOpen(false);
  }, []);

  return (
    <header className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="navbar__inner container">
        {/* Brand */}
        <Link to="/" className="navbar__brand" onClick={() => setOpen(false)}>
          <ChurchLogo size={42} />
          <span className="navbar__brand-name">MIPRECCH</span>
        </Link>

        {/* Desktop nav */}
        <nav className="navbar__links" role="navigation">
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `navbar__link${isActive ? ' navbar__link--active' : ''}`
              }
              end={to === '/'}
            >
              {label}
            </NavLink>
          ))}
          {liveStatus.is_live && (
            <a
              href={liveStatus.youtube_url || 'https://www.youtube.com'}
              target="_blank"
              rel="noopener noreferrer"
              className="navbar__live-btn"
              title={liveStatus.stream_title}
            >
              <span className="navbar__live-dot" />
              EN DIRECT
            </a>
          )}
        </nav>

        {/* Hamburger */}
        <button
          className={`navbar__hamburger${open ? ' navbar__hamburger--open' : ''}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Ouvrir le menu"
          aria-expanded={open}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile drawer */}
      <nav
        className={`navbar__mobile${open ? ' navbar__mobile--open' : ''}`}
        aria-hidden={!open}
      >
        {NAV_LINKS.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `navbar__mobile-link${isActive ? ' navbar__mobile-link--active' : ''}`
            }
            end={to === '/'}
            onClick={() => setOpen(false)}
          >
            {label}
          </NavLink>
        ))}
        {liveStatus.is_live && (
          <a
            href={liveStatus.youtube_url || 'https://www.youtube.com'}
            target="_blank"
            rel="noopener noreferrer"
            className="navbar__mobile-link navbar__mobile-live"
            onClick={() => setOpen(false)}
          >
            <span className="navbar__live-dot" /> EN DIRECT
          </a>
        )}
      </nav>
    </header>
  );
}
